import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
// import { getTruckDetails } from "../../storeSlices/dataSlice";
function Truck() {
  const [details, setdetails] = useState({
    gaadi_no: "",
    size: "",
    owner: "",
    owner_phone_no: "",

    company_name: "",
    chasis_number: "",
    engine_number: "",
    PUC: "",
    RC_number: "",
    RC_exp_date: "",
    RC_reg_date: "",
    policy_no: "",
    fitness_no: "",
  });

  const style = {
    gap: "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "normal",
    border: "1px solid black",
    padding: "10px",
    margin: "10px",
  };
  const navigate = useNavigate();
  //
  const trucks = useSelector((state) => state.dataReducer.trucks); //here trucks is the name of the slice in storeSlices/dataSlice.js
  //
  // const dispatch = useDispatch();
  const [truckdetail, settruckdetail] = useState([]);
  useEffect(() => {
    // dispatch(getTruckDetails());
    settruckdetail(trucks);
  }, []);

  const handleChange = (e) => {
    setdetails({ ...details, [e.target.name]: e.target.value });
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log(details);

    const response = await fetch(
      // `http://localhost:5000/truck/`,
      `${process.env.REACT_APP_BACKEND_URL}truck/`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
        },
        body: JSON.stringify(details),
      }
    );
    const json = await response.json();
    console.log(json);
    const inputfield = document.getElementsByClassName("entry");
    Object.entries(inputfield).forEach((element) => {
      element[1].value = "";
    });
  };
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          alignItems: "center",
        }}
      >
        <div className="chalan-form-container" style={{ width: "100%" }}>
          <form className="chalan-form" onSubmit={handleSubmit} id="bill-form">
            <label>
              vehicle Number
              <input
                className="entry"
                type="text"
                name="gaadi_no"
                value={details.gaadi_no}
                onChange={handleChange}
                required="required"
              />
            </label>
            <br />
            <label>
              Size
              <input
                className="entry"
                type="text"
                name="size"
                value={details.size}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Owner:
              <input
                className="entry"
                type="text"
                name="owner"
                value={details.owner}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Owner Phone Number
              <input
                className="entry"
                type="text"
                name="owner_phone_no"
                value={details.owner_phone_no}
                onChange={handleChange}
              />
            </label>

            <br />
            <label>
              Company Name :
              <input
                className="entry"
                type="text"
                name="company_name"
                value={details.company_name}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Chasis Number :
              <input
                className="entry"
                type="text"
                name="chasis_number"
                value={details.chasis_number}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Engine Number :
              <input
                className="entry"
                type="text"
                name="engine_number"
                value={details.engine_number}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              PUC:
              <input
                className="entry"
                type="text"
                name="PUC"
                value={details.PUC}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              RC Number:
              <input
                className="entry"
                type="text"
                name="RC_number"
                value={details.RC_number}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              RC Registration Date:
              <input
                className="entry"
                type="Date"
                name="RC_reg_date"
                value={details.RC_reg_date}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              RC Expiration Date:
              <input
                className="entry"
                type="Date"
                name="RC_exp_date"
                value={details.RC_exp_date}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Fitness Number:
              <input
                className="entry"
                type="text"
                name="fitness_no"
                value={details.fitness_no}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Policy Number:
              <input
                className="entry"
                type="text"
                name="policy_no"
                value={details.policy_no}
                onChange={handleChange}
              />
            </label>
            <br />

            <br />
            <input className="generate" type="submit" value="Add vehicle" />
          </form>
        </div>
        <br />
        <Button
          onClick={() => navigate("/dashbaord/edittrucks")}
          style={{
            border: "2px solid #ccc",
            fontSize: "18px",
            padding: "8px 16px",
          }}
        >
          View Trucks
        </Button>
        {/* <div style={{ width: "300px", marginBottom: "28px" }}>
          {truckdetail["car"]?.map((truck, index) => {
            return (
              <div key={index} style={style}>
                <p>Vehical Number : {truck.gaadi_no}</p>
                <p>Size : {truck.size}</p>
                <p>Owner : {truck.owner}</p>
                <p>Owner Phone Number : {truck.owner_phone_no}</p>
                <p>Company Name: {truck.company_name}</p>
                <p>Chasis Number : {truck.chasis_number}</p>
                <p>Engine Number : {truck.engine_number}</p>
                <p>PUC : {truck.PUC}</p>
                <p>RC Number : {truck.RC_number}</p>
                <p>RC Registration Date : {truck.RC_reg_date}</p>
                <p>RC Expiration Date : {truck.RC_exp_date}</p>
                <p>Policy Number : {truck.policy_no}</p>
                <p>Fitness Number : {truck.fitness_no}</p>
              </div>
            );
          })}
        </div> */}
      </div>
    </>
  );
}

export default Truck;
